import { colors } from '#base/js/variables.style'

export const axisColor = colors.gray
export const fontFamily = '"Barlow", sans-serif'
export const tickLabelFontSize = 13
export const axisLabelFontSize = 16

export const tickSize = 5

export const xLabelOffset = 43
export const yLabelOffset = 60

// vx offset is calculated crazy:

// https://github.com/hshoff/vx/blob/v0.0.190/packages/vx-axis/src/utils/labelTransform.js#L21
export const xLabelOffsetVX = xLabelOffset - tickSize - tickLabelFontSize - axisLabelFontSize

// https://github.com/hshoff/vx/blob/v0.0.190/packages/vx-axis/src/utils/labelTransform.js#L27
// text at 0 offset also starts at a different position (which is what the 7 represents)
export const yLabelOffsetVX = yLabelOffset - tickSize - 7
